"use strict";

$(document).ready(function () {
  var alerts = Array.prototype.slice.call(document.querySelectorAll(".alert-container"));
  if (alerts && alerts.length > 0) {
    alerts.forEach(function (alert) {
      var btn = alert.querySelector(".close");
      if (btn == null) {
        return;
      }
      btn.addEventListener("click", function () {
        var cacheTimeStr = alert.querySelector(".hdn-visibility");
        if (cacheTimeStr.value !== "") {
          var cacheTime = parseInt(cacheTimeStr.value, 10);
          var cacheKey = alert.querySelector(".hdn-cachekey");
          if (cacheKey.value === "") {
            // Create cookie 
            if (cacheTime !== 0) {
              createCookie(cacheKey.value, true, cacheTime);
            }
          }
        }
        // Hide alert
        alert.parentNode.removeChild(alert);

        // Adjusts mobile nav position when alert is closed
        var mobileMainNavPanel = document.querySelector('.mobile-main-nav');
        mobileMainNavPanel.style.top = '0';
      });
    });
  }

  // Create and store a cookie
  function createCookie(cookieName, cookieValue, minutesToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + minutesToExpire * 60 * 1000);
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString() + "; path=/";
  }
});